import React from "react";
import icons from "../../../assets/icons/icons";
import "./email-setup-banner.scss";

const EmailSetUpBanner = () => {
  return (
    <div className="email-setup-banner">
      <img src={icons.TermOfServicesInfo} alt="info icon" />
      <p className="email-setup-text">
        <strong>Email Setup Incomplete:</strong> Configure your email setup to
        send notifications from your organization’s email address instead of the
        default AFP email.
      </p>
    </div>
  );
};

export default EmailSetUpBanner;